// extracted by mini-css-extract-plugin
export var button = "_60-0";
export var icon = "_60-1";